import React from 'react';
import styles from './AlertComponent.module.scss';
import { CloseOutlined } from '@ant-design/icons';

interface AlertComponentProps {
  message: string;
  onClose: () => void;
}

const AlertComponent: React.FC<AlertComponentProps> = ({ message, onClose }) => {
  return (
    <div className={styles.alertContainer}>
      <div className={styles.icon}>!</div>
      <span className={styles.message}>{message}</span>
      <CloseOutlined className={styles.closeIcon} onClick={onClose} />
    </div>
  );
};

export default AlertComponent;
